import { useState } from 'react';
import { useIntl } from 'react-intl';
import { ButtonUI } from 'sonata-react-components';

import { postDataSegment } from '@/resources/audienceTargeting.resources';
import { SelectedList } from '../components/SelectedList';
import { PreviousCampaignStyled } from './PreviousCampaign.styles';
import { PreviousCampaignModal } from './PreviousCampaignModal';

type Props = {
  onChange: (settings: Partial<Parameters<typeof postDataSegment>['0']>) => void;
};

type State = {
  deletedItems: string[];
  selectedItems: Record<string, any>[];
  showModal: boolean;
};

function PreviousCampaign({ onChange }: Props) {
  const { formatMessage } = useIntl();

  const [{ deletedItems, selectedItems, showModal }, setState] = useState<State>({
    deletedItems: [],
    selectedItems: [],
    showModal: false
  });

  const handleModal = () => {
    setState(prevState => ({
      ...prevState,
      showModal: !showModal
    }));
  };

  const handleModalSave = (items: Record<string, any>[]) => {
    setState(prevState => ({
      ...prevState,
      selectedItems: items
    }));
    onChange({
      campaignIds: items.map(item => item._id),
      type: 'campaign-forecasting'
    });
  };

  const handleDeleteItems = (deletedItem: string) => {
    const updatedDeletedItems = [...deletedItems, deletedItem];
    setState(prevState => ({
      ...prevState,
      deletedItems: updatedDeletedItems
    }));
    const updatedFilteredItemsIds = selectedItems
      .filter(item => !updatedDeletedItems.includes(item._id))
      .map(item => item._id);

    onChange({
      campaignIds: updatedFilteredItemsIds,
      type: 'campaign-forecasting'
    });
  };

  const filteredItems = selectedItems.filter(item => !deletedItems.includes(item._id));

  const defaultSelectedItems = filteredItems.reduce((acc, item) => {
    return {
      ...acc,
      [item._id]: true
    };
  }, {});

  return (
    <PreviousCampaignStyled className="previousCampaign" showButton={filteredItems.length === 0}>
      <div className="previousCampaign__container">
        {filteredItems.length === 0 ? (
          <ButtonUI
            className="previousCampaign__button"
            id="previousCampaign-button"
            onClick={handleModal}
            size="medium"
            text={formatMessage({
              defaultMessage: 'Select Associated Campaign',
              id: 'targeting.audienceTargeting.audienceProfile.previousCampaign.buttonAssociatedCampaign'
            })}
            type="primary"
          />
        ) : (
          <SelectedList
            items={filteredItems}
            onDeleteItems={handleDeleteItems}
            onModalOpen={handleModal}
            showCount
            title={formatMessage({
              defaultMessage: 'Campaign Selected:',
              id: 'targeting.audienceTargeting.audienceProfile.previousCampaign.list.title'
            })}
          />
        )}
      </div>
      {showModal && (
        <PreviousCampaignModal
          defaultSelectedItems={defaultSelectedItems}
          isModalOpened={showModal}
          onModalClose={handleModal}
          onModalSave={handleModalSave}
          theme="light"
        />
      )}
    </PreviousCampaignStyled>
  );
}

export default PreviousCampaign;
